@for (token of [renderToken()]; track token) {
  <adp-label [labelKey]="labelKey()" [context]="context()"></adp-label>
}
